var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content3"},[_c('data-table-sub-user',{attrs:{"data":_vm.result,"header":_vm.header,"body":_vm.body}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }